import React from 'react'
import "./styles/Preloader.scss"

const Preloader = () => {
    return (
        <div className="Preloader" id="preloader">
            <p className="Miho">Michael Hochreiter</p>
            <p className="Port">Portfolio</p>
        </div>
    )
}

export default Preloader